<template>
    <div class="ProductCarousel">
        <div class="c-section">
            <div class="c-products-row items" ref="slider" v-if="objects" @scroll="handleScroll" @mousedown="mousedown" @mouseleave="mouseleave" @mouseup="mouseup" @mousemove="mousemove">
                <div class="c-item" :key="obj" v-for="obj in objects">
                    <BlogCard :carousel="true" :obj="obj" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BlogCard from '@/components/BlogCard.vue'

export default {
  name: 'ProductCarousel',
  props: {
    objects: null
  },
  components: {
    BlogCard
  },
  data () {
    return {
      isDown: false,
      startX: null,
      scrollLeft: null,
      interval: null
    }
  },
  methods: {
    mousedown: function (e) {
      this.isDown = true
      this.$refs.slider.classList.add('active')
      this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.scrollLeft = this.$refs.slider.scrollLeft
    },
    mouseleave: function () {
      this.isDown = false
      try {
        this.$refs.slider.classList.remove('active')
      } catch {}
    },
    mouseup: function () {
      this.isDown = false
      this.$refs.slider.classList.remove('active')
    },
    mousemove: function (e) {
      if (this.isDown) {
        e.preventDefault()
        const x = e.pageX - this.$refs.slider.offsetLeft
        const walk = (x - this.startX) * 2
        this.$refs.slider.scrollLeft = this.scrollLeft - walk
      }
    },
    handleScroll: function () {
      if (this.interval && this.$refs.slider.scrollLeft < -80) {
        clearInterval(this.interval)
        this.interval = null
      }
    }
  },
  unmounted () {
    clearInterval(this.interval)
    this.interval = null
  },
  mounted: function () {
    if (this.objects) {
      this.interval = setInterval(() => {
        if (this.$refs.slider) {
          this.$refs.slider.style['scroll-behavior'] = 'smooth'
          this.$refs.slider.scrollLeft = this.scrollLeft - 70
          setTimeout(() => {
            if (this.$refs.slider) {
              this.$refs.slider.scrollLeft = this.scrollLeft + 70
              this.$refs.slider.style['scroll-behavior'] = 'auto'
            }
          }, 200)
        }
      }, 10000)
    }
  }
}
</script>
<style scoped>
.c-item{margin: 0px 12px;}
.items {
  position: relative;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: all 0.2s;
  transform: scale(0.97);
  will-change: transform;
  user-select: none;
  cursor: pointer;
  scrollbar-width: none;
}

.items.active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1);
}
</style>
